import _ from "lodash";

import { IDevice, IApiKey, IAuthorization } from "@common/models";
import { UserActionTypes, UserActions } from "./user.actions";

export interface IUserSate {
  departmentName?: string;
  userId?: string;
  username?: string;
  isActive?: boolean;
  name?: string;
  apiKeys?: IApiKey[];
  authorization?: IAuthorization[];
  devices?: IDevice[];
}

const defaultState = {};

export default function(
  state: IUserSate = defaultState,
  action: UserActionTypes
) {
  if (action.payload instanceof Error) {
    return state;
  }

  switch (action.type) {
    case UserActions.LOGIN_SUCCEEDED:
      return { ...state, ...action.payload };
    case UserActions.GET_DEVICES_RESPONSE: {
      return { ...state, devices: action.payload };
    }
    case UserActions.USER_UPDATE_RESPNOSE: {
      return { ...state, ...action.payload };
    }
    case UserActions.GET_API_KEY_RESPONSE: {
      return { ...state, apiKeys: action.payload };
    }
    case UserActions.LOGOUT:
    case UserActions.CHANGE_PASSWORD_RESPONSE:
      return defaultState;

    default:
      return state;
  }
}
